import { render, staticRenderFns } from "./ResendEmailModal.vue?vue&type=template&id=70aca619&scoped=true&"
import script from "./ResendEmailModal.vue?vue&type=script&lang=js&"
export * from "./ResendEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./ResendEmailModal.vue?vue&type=style&index=0&id=70aca619&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aca619",
  null
  
)

export default component.exports